////////////////////////////////////////

const user        = require('@/schemas/user.schema.js');
const role        = require('@/schemas/role.schema.js');
const item        = require('@/schemas/item.schema.js');
const company     = require('@/schemas/company.schema.js');
const search_item = require('@/schemas/search_item.schema.js');

module.exports = {
    user,
    role,
    item,
    company,
    search_item,
};

